import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgHeadphonesMicrophone = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-headphones-microphone';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.88 2.279C9.732 2.43 7.684 3.431 6.27 5.02a7.9 7.9 0 0 0-1.988 4.56c-.026.269-.042 1.953-.042 4.33v3.89l2.71-.023c1.491-.013 2.733-.031 2.76-.039.039-.012.05-.699.05-3.257V11.24h-4l.001-.69c.001-.741.064-1.34.195-1.853C6.542 6.4 8.45 4.544 10.82 3.965c.623-.152.913-.184 1.68-.184s1.057.032 1.68.184c1.971.481 3.648 1.853 4.473 3.657.434.95.587 1.716.587 2.947v.671h-4v5.508l-1.39 1.746-1.39 1.746h-1.82v1.52l1.27-.002 1.27-.002 1.58-2 1.58-2 1.82.012 1.82.012.012-.37.011-.37h.761l-.014-3.79c-.016-4.135-.009-3.997-.257-4.95-.98-3.765-4.609-6.302-8.613-6.021M8.24 14.52v1.76H5.76v-3.52h2.48zm11 0v1.76h-2.48v-3.52h2.48z"
    })
  }));
});
export default SvgHeadphonesMicrophone;